import { italicItem } from "./items/italic";
import { boldItem } from "./items/bold";
import { codeItem } from "./items/code";
import { alignCenterItem } from "./items/alignment";
import { headingOneItem, headingTwoItem } from "./items/heading";
import { codeBlockItem } from "./items/codeBlock";
import { linkItem } from "./items/link";

export const tooltipMenuItems = [
  boldItem,
  italicItem,
  codeItem,
  linkItem,
  codeBlockItem,
  headingOneItem,
  headingTwoItem,
  alignCenterItem,
];
